export interface Product {
  id: string;
  brand: string;
  name: string;
  description: string;
  image: string;
  images?: string[];
  category: string;
  badge?: string;
  details?: string;
  weight?: string;
  tags?: string[];
  ingredients?: string[];
  nutritionFacts?: { label: string; value: string }[];
  benefits?: string[];
  howToUse?: string;
  shelfLife?: string;
  origin?: string;
}

export const products: Product[] = [
  {
    id: '1',
    brand: 'FASSNUT',
    name: 'Makhana Snowflakes',
    description: 'Light & crispy snowflake-shaped fox nuts, a healthy guilt-free snack',
    details: 'Our Makhana Snowflakes are carefully sourced from the finest lotus seeds and roasted to perfection. Rich in protein, low in calories, and completely natural — perfect for health-conscious snacking. No artificial flavors, no preservatives.',
    image: 'https://static.readdy.ai/image/3301efb4abc894ce1097fc48d2d46708/6cabdef9482c1e4e3a79baae13ecbe41.png',
    category: 'Makhana',
    badge: 'Bestseller',
    weight: '100g',
    tags: ['Gluten Free', 'High Protein', 'Natural'],
    ingredients: ['Fox Nuts (Makhana)', 'Refined Sunflower Oil', 'Rock Salt', 'Natural Spices'],
    nutritionFacts: [
      { label: 'Energy', value: '347 kcal / 100g' },
      { label: 'Protein', value: '9.7g' },
      { label: 'Carbohydrates', value: '76.9g' },
      { label: 'Fat', value: '0.1g' },
      { label: 'Fibre', value: '14.5g' },
      { label: 'Sodium', value: '210mg' },
    ],
    benefits: [
      'High in protein and low in calories — ideal for weight management',
      'Rich in magnesium, potassium, and phosphorus',
      'Gluten-free and suitable for all age groups',
      'No artificial colors, flavors, or preservatives',
      'Antioxidant-rich — supports healthy aging',
    ],
    howToUse: 'Best enjoyed as a standalone snack. Can also be added to trail mixes, kheer, or raita. Store in an airtight container after opening.',
    shelfLife: '6 months from date of manufacture',
    origin: 'Bihar, India',
  },
  {
    id: '2',
    brand: 'FASSFALLI',
    name: 'Mix Dry Fruits',
    description: 'Premium blend of cashews, almonds, raisins, pistachios & more',
    details: 'A handpicked premium mix of the finest dry fruits — cashews, almonds, raisins, pistachios, walnuts, and dried cranberries. Packed with essential nutrients, healthy fats, and natural energy. Great for snacking, gifting, or adding to recipes.',
    image: 'https://storage.readdy-site.link/project_files/c44a33b9-73a7-4f29-8c86-80a04dae53c1/8d1d8fa0-7246-410f-84e4-1ac28bb4f921_MixDryFruits.jpg?v=db41ce26a1c774ed02b84144ec217333',
    category: 'Snacks',
    badge: 'New',
    weight: '250g',
    tags: ['Nutrient Rich', 'No Added Sugar', 'Premium'],
    ingredients: ['Cashews', 'Almonds', 'Raisins', 'Pistachios', 'Walnuts', 'Dried Cranberries', 'Dried Apricots'],
    nutritionFacts: [
      { label: 'Energy', value: '580 kcal / 100g' },
      { label: 'Protein', value: '14g' },
      { label: 'Carbohydrates', value: '42g' },
      { label: 'Fat', value: '38g' },
      { label: 'Fibre', value: '6g' },
      { label: 'Sodium', value: '15mg' },
    ],
    benefits: [
      'Rich in heart-healthy omega-3 fatty acids',
      'Excellent source of vitamins E, B6, and minerals',
      'Natural energy booster — great pre/post workout',
      'No added sugar, salt, or preservatives',
      'Supports brain health and immunity',
    ],
    howToUse: 'Enjoy a handful as a daily snack. Add to oatmeal, yogurt, salads, or baked goods. Ideal as a healthy gift.',
    shelfLife: '9 months from date of manufacture',
    origin: 'Sourced from across India',
  },
  {
    id: '3',
    brand: 'RAJSIP',
    name: 'Premium Jeera (Cumin)',
    description: 'Whole cumin seeds for authentic Indian cooking',
    details: 'Sourced from the finest cumin farms, our Premium Jeera is sun-dried and carefully cleaned to retain its natural aroma and flavor. Perfect for tempering, curries, and traditional Indian recipes.',
    image: 'https://public.readdy.ai/ai/img_res/209c1a19cb46baacbbe3d0b00e35afb7.jpg',
    category: 'Spices',
    weight: '200g',
    tags: ['Pure', 'Aromatic', 'FSSAI Certified'],
    ingredients: ['100% Pure Cumin Seeds (Cuminum cyminum)'],
    nutritionFacts: [
      { label: 'Energy', value: '375 kcal / 100g' },
      { label: 'Protein', value: '17.8g' },
      { label: 'Carbohydrates', value: '44.2g' },
      { label: 'Fat', value: '22.3g' },
      { label: 'Fibre', value: '10.5g' },
      { label: 'Iron', value: '66.4mg' },
    ],
    benefits: [
      'Aids digestion and relieves bloating',
      'Rich in iron — supports healthy blood',
      'Natural antioxidant and anti-inflammatory',
      'Boosts metabolism and immune function',
      'No additives — 100% pure whole seeds',
    ],
    howToUse: 'Use for tempering (tadka) in dals, curries, and rice dishes. Dry roast and grind for fresh jeera powder. Add to raita and chaas.',
    shelfLife: '12 months from date of manufacture',
    origin: 'Rajasthan & Gujarat, India',
  },
  {
    id: '4',
    brand: 'RAJSIP',
    name: 'Dhaniya (Coriander)',
    description: 'Whole coriander seeds for rich flavor',
    details: 'Our whole coriander seeds are handpicked and naturally dried to preserve their citrusy, earthy aroma. Ideal for grinding fresh or using whole in tadkas and marinades.',
    image: 'https://readdy.ai/api/search-image?query=Whole%20coriander%20seeds%20dhaniya%20in%20elegant%20glass%20jar%20on%20warm%20cream%20background%20professional%20spice%20photography%20soft%20lighting%20high%20quality%20product%20shot%20Indian%20spices&width=400&height=400&orientation=squarish&seq=4',
    category: 'Spices',
    weight: '200g',
    tags: ['Pure', 'Natural', 'FSSAI Certified'],
    ingredients: ['100% Pure Coriander Seeds (Coriandrum sativum)'],
    nutritionFacts: [
      { label: 'Energy', value: '298 kcal / 100g' },
      { label: 'Protein', value: '12.4g' },
      { label: 'Carbohydrates', value: '54.9g' },
      { label: 'Fat', value: '17.8g' },
      { label: 'Fibre', value: '41.9g' },
      { label: 'Calcium', value: '709mg' },
    ],
    benefits: [
      'Supports healthy digestion and gut health',
      'Rich in dietary fibre and calcium',
      'Natural blood sugar regulator',
      'Anti-inflammatory and antibacterial properties',
      'Freshly packed to retain maximum aroma',
    ],
    howToUse: 'Dry roast and grind for fresh coriander powder. Use whole in pickles, marinades, and spice blends. Add to curries and dals.',
    shelfLife: '12 months from date of manufacture',
    origin: 'Madhya Pradesh, India',
  },
  {
    id: '5',
    brand: 'RAJSIP',
    name: 'Haldi (Turmeric)',
    description: 'Pure turmeric powder with natural color',
    details: 'Our Haldi is made from premium Lakadong turmeric, known for its high curcumin content and vibrant golden color. No artificial colors, no fillers — just pure, potent turmeric.',
    image: 'https://readdy.ai/api/search-image?query=Pure%20turmeric%20powder%20haldi%20in%20glass%20jar%20on%20warm%20background%20vibrant%20yellow%20color%20professional%20spice%20photography%20soft%20lighting%20high%20quality%20product%20shot&width=400&height=400&orientation=squarish&seq=5',
    category: 'Spices',
    badge: 'Premium',
    weight: '200g',
    tags: ['High Curcumin', 'Pure', 'Antioxidant'],
    ingredients: ['100% Pure Turmeric Powder (Curcuma longa) — Lakadong Variety'],
    nutritionFacts: [
      { label: 'Energy', value: '354 kcal / 100g' },
      { label: 'Protein', value: '7.8g' },
      { label: 'Carbohydrates', value: '64.9g' },
      { label: 'Fat', value: '9.9g' },
      { label: 'Curcumin', value: '5–7% (High)' },
      { label: 'Iron', value: '41.4mg' },
    ],
    benefits: [
      'High curcumin content — powerful anti-inflammatory',
      'Boosts immunity and supports joint health',
      'Natural antioxidant — fights free radicals',
      'Supports liver health and detoxification',
      'No artificial color — vibrant natural golden hue',
    ],
    howToUse: 'Add to curries, dals, milk (golden milk / haldi doodh), and marinades. Use in face packs for skin benefits. A pinch goes a long way.',
    shelfLife: '18 months from date of manufacture',
    origin: 'Meghalaya (Lakadong), India',
  },
  {
    id: '6',
    brand: 'RAJSIP',
    name: 'Dhaniya Powder',
    description: 'Finely ground coriander powder',
    details: 'Stone-ground from premium whole coriander seeds, our Dhaniya Powder retains the full flavor and aroma. Perfect for curries, gravies, and spice blends.',
    image: 'https://readdy.ai/api/search-image?query=Coriander%20powder%20dhaniya%20powder%20in%20glass%20jar%20on%20warm%20cream%20background%20professional%20spice%20photography%20soft%20natural%20lighting%20high%20quality%20product%20shot%20Indian%20spices&width=400&height=400&orientation=squarish&seq=6',
    category: 'Spices',
    weight: '200g',
    tags: ['Stone Ground', 'Pure', 'FSSAI Certified'],
    ingredients: ['100% Pure Stone-Ground Coriander Powder'],
    nutritionFacts: [
      { label: 'Energy', value: '298 kcal / 100g' },
      { label: 'Protein', value: '12.4g' },
      { label: 'Carbohydrates', value: '54.9g' },
      { label: 'Fat', value: '17.8g' },
      { label: 'Fibre', value: '41.9g' },
      { label: 'Calcium', value: '709mg' },
    ],
    benefits: [
      'Stone-ground to preserve natural oils and aroma',
      'Adds authentic flavor to curries and gravies',
      'Rich in dietary fibre and essential minerals',
      'No artificial additives or fillers',
      'Freshly packed in airtight packaging',
    ],
    howToUse: 'Add to curries, gravies, marinades, and spice blends. Use as a base spice in most Indian cooking. Pairs well with jeera and haldi.',
    shelfLife: '12 months from date of manufacture',
    origin: 'Madhya Pradesh, India',
  },
  {
    id: '7',
    brand: 'FAASTEA',
    name: 'Premium Tea Blend',
    description: 'Rich aromatic tea for perfect mornings',
    details: 'A carefully curated blend of Assam and Darjeeling tea leaves, our Premium Tea Blend delivers a rich, full-bodied cup with a beautiful amber color. Perfect for chai lovers who appreciate quality.',
    image: 'https://static.readdy.ai/image/3301efb4abc894ce1097fc48d2d46708/1c85c6075a2c1d4ce0f69fc4c8988ca2.png',
    category: 'Tea',
    badge: 'Popular',
    weight: '250g',
    tags: ['Assam Blend', 'Rich Flavor', 'Premium'],
    ingredients: ['Assam CTC Tea Leaves', 'Darjeeling Tea Leaves', 'Natural Flavoring'],
    nutritionFacts: [
      { label: 'Energy', value: '1 kcal / cup' },
      { label: 'Caffeine', value: '~40mg / cup' },
      { label: 'Antioxidants', value: 'High (Polyphenols)' },
      { label: 'Tannins', value: 'Moderate' },
    ],
    benefits: [
      'Rich in antioxidants — supports heart health',
      'Natural caffeine for a gentle energy boost',
      'Improves focus and mental alertness',
      'Supports metabolism and digestion',
      'Premium Assam-Darjeeling blend for full body flavor',
    ],
    howToUse: 'Boil 1 tsp of tea in 200ml water for 2–3 minutes. Add milk and sugar to taste. For best results, use fresh water and avoid over-boiling.',
    shelfLife: '24 months from date of manufacture',
    origin: 'Assam & Darjeeling, India',
  },
  {
    id: '8',
    brand: 'BOOSTON',
    name: 'Energy Tea',
    description: 'Invigorating tea blend for energy boost',
    details: 'Specially formulated with green tea, ginger, and natural herbs, our Energy Tea gives you a natural boost without the jitters. Great for mornings or afternoon pick-me-ups.',
    image: 'https://static.readdy.ai/image/3301efb4abc894ce1097fc48d2d46708/1c85c6075a2c1d4ce0f69fc4c8988ca2.png',
    category: 'Tea',
    weight: '200g',
    tags: ['Green Tea', 'Natural Energy', 'Herbal'],
    ingredients: ['Green Tea Leaves', 'Dried Ginger', 'Tulsi (Holy Basil)', 'Lemongrass', 'Black Pepper', 'Cardamom'],
    nutritionFacts: [
      { label: 'Energy', value: '2 kcal / cup' },
      { label: 'Caffeine', value: '~25mg / cup' },
      { label: 'Antioxidants', value: 'Very High (EGCG)' },
      { label: 'Adaptogens', value: 'Tulsi, Ginger' },
    ],
    benefits: [
      'Natural energy without caffeine crash',
      'Ginger and tulsi boost immunity',
      'Green tea EGCG — powerful antioxidant',
      'Supports metabolism and fat burning',
      'Calming yet energizing — perfect any time of day',
    ],
    howToUse: 'Steep 1 tsp in 200ml hot water (80°C) for 3 minutes. Do not boil. Add honey or lemon for extra flavor. Best consumed without milk.',
    shelfLife: '18 months from date of manufacture',
    origin: 'Assam & Kerala, India',
  },
  {
    id: '9',
    brand: 'SACHAR',
    name: 'Mera Achar (Pickles)',
    description: 'Traditional homemade style pickles',
    details: 'Made using age-old family recipes, our Mera Achar is prepared with fresh mangoes, mustard oil, and a secret blend of spices. No artificial preservatives — just authentic homemade taste.',
    image: 'https://storage.readdy-site.link/project_files/c44a33b9-73a7-4f29-8c86-80a04dae53c1/7faf523c-633b-40ba-834c-b286280842f0_WhatsApp-Image-2026-04-02-at-11.18.43-PM.jpeg?v=fcc2909e2dba0c7c897b539c12d94430',
    images: [
      'https://storage.readdy-site.link/project_files/c44a33b9-73a7-4f29-8c86-80a04dae53c1/7faf523c-633b-40ba-834c-b286280842f0_WhatsApp-Image-2026-04-02-at-11.18.43-PM.jpeg?v=fcc2909e2dba0c7c897b539c12d94430',
      'https://storage.readdy-site.link/project_files/c44a33b9-73a7-4f29-8c86-80a04dae53c1/da39d79d-920e-4f3d-ad33-4ecf691e129e_WhatsApp-Image-2026-04-02-at-11.18.48-PM.jpeg?v=6ab83b44093ed4c58290730ec1cc080b',
      'https://storage.readdy-site.link/project_files/c44a33b9-73a7-4f29-8c86-80a04dae53c1/44a51372-8cc7-4c48-a303-2b649bb3609a_WhatsApp-Image-2026-04-02-at-11.18.47-PM.jpeg?v=6a7bc716aaf61222a1bd0dd083975c40',
      'https://storage.readdy-site.link/project_files/c44a33b9-73a7-4f29-8c86-80a04dae53c1/c3afa77d-1376-467b-ae85-b9eb88a33a31_WhatsApp-Image-2026-04-02-at-11.18.46-PM-1.jpeg?v=29029626edf503320ede37735026b09a',
      'https://storage.readdy-site.link/project_files/c44a33b9-73a7-4f29-8c86-80a04dae53c1/27ff74f7-4fcd-4201-8aea-cb3f5ce82a85_WhatsApp-Image-2026-04-02-at-11.18.45-PM.jpeg?v=47b69882a38e7d552f0ce6309d7fb4af',
      'https://storage.readdy-site.link/project_files/c44a33b9-73a7-4f29-8c86-80a04dae53c1/45a8f502-a8a6-47eb-9ea4-0203b7bb2e69_WhatsApp-Image-2026-04-02-at-11.18.44-PM.jpeg?v=2b296382ed4945e7d2eca6e68239b092',
    ],
    category: 'Pickles',
    badge: 'Homemade',
    weight: '400g',
    tags: ['No Preservatives', 'Traditional Recipe', 'Homemade'],
    ingredients: ['Raw Mango', 'Mustard Oil', 'Salt', 'Fenugreek Seeds', 'Fennel Seeds', 'Red Chilli Powder', 'Turmeric', 'Asafoetida (Hing)', 'Secret Spice Blend'],
    nutritionFacts: [
      { label: 'Energy', value: '85 kcal / 100g' },
      { label: 'Carbohydrates', value: '8.2g' },
      { label: 'Fat', value: '5.4g' },
      { label: 'Protein', value: '1.1g' },
      { label: 'Sodium', value: '1850mg' },
      { label: 'Fibre', value: '2.3g' },
    ],
    benefits: [
      'Made with traditional family recipe — authentic taste',
      'No artificial preservatives or colors',
      'Mustard oil base — rich in omega-3 fatty acids',
      'Probiotic-rich — supports gut health',
      'Perfect accompaniment to every Indian meal',
    ],
    howToUse: 'Serve as a side with dal-chawal, parathas, or any Indian meal. Use as a condiment in sandwiches and wraps. Refrigerate after opening.',
    shelfLife: '12 months (unopened). Refrigerate after opening and consume within 3 months.',
    origin: 'Homemade — India',
  },
  {
    id: '10',
    brand: 'WATLER',
    name: 'Drinking Water',
    description: 'Pure mineral water for healthy hydration',
    details: 'Sourced from natural springs and purified through a multi-stage filtration process, WATLER drinking water is rich in essential minerals and completely safe for daily consumption.',
    image: 'https://storage.readdy-site.link/project_files/c44a33b9-73a7-4f29-8c86-80a04dae53c1/96640edd-8e88-4367-8213-f4dd46d2a40d_Walter.jpg?v=455f1e923d8920a21fb1dcd822d91d47',
    category: 'Water',
    weight: '1L',
    tags: ['Mineral Rich', 'Pure', 'BIS Certified'],
    ingredients: ['Natural Spring Water', 'Essential Minerals (Calcium, Magnesium, Potassium)'],
    nutritionFacts: [
      { label: 'Energy', value: '0 kcal' },
      { label: 'TDS', value: '150–200 ppm' },
      { label: 'pH', value: '7.2–7.8 (Alkaline)' },
      { label: 'Calcium', value: '18mg/L' },
      { label: 'Magnesium', value: '5mg/L' },
      { label: 'Potassium', value: '2mg/L' },
    ],
    benefits: [
      'Multi-stage purification — safe for all ages',
      'Balanced mineral content for daily hydration',
      'Slightly alkaline pH — supports body balance',
      'BIS certified — meets all Indian safety standards',
      'Eco-friendly packaging — recyclable bottle',
    ],
    howToUse: 'Best consumed chilled. Ideal for drinking, cooking, and preparing beverages. Store in a cool, dry place away from direct sunlight.',
    shelfLife: '12 months from date of manufacture (unopened)',
    origin: 'India',
  },
];

export const faqs = [
  {
    question: 'What makes Faasley products different from others?',
    answer: 'Faasley products are crafted with a focus on hygiene, authentic taste, and homemade-style preparation. We use premium quality ingredients and maintain strict quality control throughout the manufacturing process.',
  },
  {
    question: 'Are your products 100% natural and chemical-free?',
    answer: 'Yes, all Faasley products are made with natural ingredients. Our spices are pure without any artificial colors or preservatives. We believe in delivering authentic flavors the natural way.',
  },
  {
    question: 'How do you ensure product quality and hygiene?',
    answer: 'We follow strict FSSAI guidelines and maintain a hygienic manufacturing environment. All products undergo quality testing before packaging to ensure you receive only the best.',
  },
  {
    question: 'What is your shipping and delivery policy?',
    answer: 'We deliver across India within 3-7 business days. Shipping is free for orders above ₹499. For orders below ₹499, a nominal shipping charge of ₹49 applies.',
  },
  {
    question: 'Do you offer bulk orders or wholesale pricing?',
    answer: 'Yes, we offer special pricing for bulk orders and wholesale inquiries. Please contact us through the contact form or email us at info@faasley.com for wholesale pricing.',
  },
  {
    question: 'What is your return and refund policy?',
    answer: 'We accept returns within 7 days of delivery if the product is damaged or defective. For eligible returns, we offer full refunds or product replacements as per your preference.',
  },
  {
    question: 'How should I store the products?',
    answer: 'Store spices in a cool, dry place away from direct sunlight. Pickles should be refrigerated after opening. Makhana and snacks should be kept in an airtight container to maintain freshness.',
  },
  {
    question: 'Are you looking for investors or partners?',
    answer: 'Yes, we are actively seeking strategic partners and investors who can help us expand our distribution network and grow Faasley into a national brand. Check our Investor section for details.',
  },
];
